export const PATH = '/smartcargas/rounds';
export const PAGE_TITLE = 'Smart Cargas';

export const INITIAL_PAGE_NUMBER = 1;
export const PAGE_SIZE = 30;
export const SELECTION_LIMIT = 100;
